import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rl-text-center"
};
const _hoisted_2 = {
  class: "rl-row-bottom-calc-30 rl-text-h3",
  style: {
    "margin": "0",
    "color": "#909090"
  }
};
const _hoisted_3 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    justify: "center",
    align: "middle",
    style: {
      "height": "calc(100vh - 120px)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("LOGIN.PLEASE_LOG_IN")), 1), _createElementVNode("a", {
      href: $setup.loginUrl,
      target: "_self"
    }, [_createVNode(_component_el_button, {
      class: "round-button rl-uppercase rl-text-body-2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.LOG_IN")), 1)]),
      _: 1
    })], 8, _hoisted_3)]), _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))]),
    _: 1
  });
}